import { render } from "./BarsChart.vue?vue&type=template&id=c424d424&scoped=true"
import script from "./BarsChart.vue?vue&type=script&lang=js"
export * from "./BarsChart.vue?vue&type=script&lang=js"

import "./BarsChart.vue?vue&type=style&index=0&id=c424d424&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c424d424"]])

export default __exports__